import { z } from 'zod';

import { type BaseItem } from '../common.js';

export const BaseAssistantSchema = z.object({
  organizationId: z.string(),
  practiceId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  createdById: z.string(),
  updatedById: z.string(),
  liveDefinitionId: z.string().nullable(),
});

type BaseAssistant = z.infer<typeof BaseAssistantSchema>;
export type Assistant = BaseItem & BaseAssistant;
export type CreateValues = Omit<BaseAssistant, 'liveDefinitionId' | 'createdById' | 'updatedById'>;
export type UpdateValues = Partial<Omit<CreateValues, 'organizationId'>>;

export const FindAllOptionsSchema = z.object({
  organizationId: z.string().optional(),
  name: z.string().optional(),
  ids: z.array(z.uuid()).optional(),
});
export type FindAllOptions = z.infer<typeof FindAllOptionsSchema>;
